






































































import _ from 'lodash';
// eslint-disable-next-line no-unused-vars
import { Route } from 'vue-router';
import { editFactory } from '@/main/pages';
import { TabulkovaPozice } from '@/modules/ciselnik/dilenske/tabulkovaPozice';
// eslint-disable-next-line no-unused-vars
import { Row } from '@/main/utils/table';
// eslint-disable-next-line no-unused-vars
import { DropdownItem } from '@/main/store/@types/dropdown.d';

import { store } from './store/edit';
import { NAME, TAB_NAMES } from './constants';
import { editMutations } from './store/types';
import { OdhadyPracnostiPodil } from '../odhadyPracnostiPodil';
import { apiProvider } from './api';

export default editFactory(NAME, store).extend({
	components: {
		TabulkovaPoziceSelect: TabulkovaPozice.components.Select,
	},
	data() {
		return {
			tabItems: {
				[TAB_NAMES.ZAKLADNI_INFORMACE]: { id: 'zakladniInformace', labelKey: 'tsPPOdhadMain' },
				[TAB_NAMES.KLONOVANI]: { id: 'klonovani', labelKey: 'tsPPOdhadClone' },
			},
			tabNames: TAB_NAMES,
			dependencies: { OdhadyPracnostiPodil: OdhadyPracnostiPodil.name },
		};
	},
	created() {
		this.mainCollapse = [this.dependencies.OdhadyPracnostiPodil];
		this.fetchTabulkovaPozice();
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				tabulkovaPozice: `${this.storeUri}/${editMutations.TABULKOVA_POZICE_SELECT_MAPPER}`,
			};
		},
		podilySum(): number {
			const podilColumnIndex = this.dependentTables.OdhadyPracnostiPodil.cellNames!.PODIL;
			return _.reduce(this.dependentTables.OdhadyPracnostiPodil.rows,
				(sum: number, n: Row) => sum + parseInt(n.cells[podilColumnIndex], 10), 0);
		},
		tablpoziceKlonDropDown(): DropdownItem[] {
			const textIndex = 3;
			const valueIndex = 2;
			return this.TablpoziceRows.map((row: { Cells: any[] }) => ({
				Disabled: false,
				Label: null,
				Text: row.Cells[textIndex],
				Value: row.Cells[valueIndex],
			}));
		},
	},
	watch: {
		VyrobekvozOznKlon() {
			this.TablpoziceKlon = [];
			this.fetchTabulkovaPozice();
		},
	},
	methods: {
		async shouldDestroyPage(to: Route) {
			if (!to.name?.includes(OdhadyPracnostiPodil.name) && this.dependentTables.OdhadyPracnostiPodil.rows.length && this.podilySum !== 100) {
				this.showErrorAlert({ message: 'PodilTotal' });
				return false;
			}
			return (!this.shouldRemoveFromPageManager(to) || this.getConfirmationForUnsavedEditForm());
		},
		oznacitVse() {
			this.TablpoziceKlon = this.tablpoziceKlonDropDown.map((tabPozizeItem: DropdownItem) => tabPozizeItem.Value);
		},
		async klonovat() {
			const resp = this.isCreateMode ? await this.changeToEdit() : await this.save(false);
			if (resp instanceof Error) return;
			try {
				this.startLoading();
				await apiProvider.klon(this.ZaznamId!, this.TablpoziceKlon);
			} finally {
				this.endLoading();
			}
		},
	},
});
